"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Petra = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const SelectPartyToSendDelegate_1 = require("../../inputs/SelectPartyToSendDelegate");
const Resources_1 = require("../../Resources");
const Size_1 = require("../render/Size");
const Darwin_1 = require("./Darwin");
class Petra extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.PETRA,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L16',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.opgArrow().text('ACTIVATE THE BELOW ABILITY');
                    b.br;
                    b.text('REPLACE', Size_1.Size.SMALL).delegates(1).colon().megacredits(3).asterix();
                    b.br.br;
                    b.plus().delegates(3).asterix;
                }),
                description: 'Once per game, replace as many Neutral delegates as possible with your delegates. Gain 3 M€ for each delegate replaced this way. Place 3 Neutral delegates.',
            },
        });
        this.isDisabled = false;
    }
    play() {
        return undefined;
    }
    canAct(player) {
        const turmoil = player.game.turmoil;
        if (turmoil === undefined)
            return false;
        return this.isDisabled === false;
    }
    action(player) {
        const game = player.game;
        const turmoil = game.turmoil;
        let playerTotalDelegateCount = turmoil.getDelegatesInReserve(player.id);
        if (turmoil.lobby.has(player.id))
            playerTotalDelegateCount += 1;
        const replaceNeutralDelegateTitle = 'Select where to replace a Neutral delegate';
        const neutralDelegateCount = turmoil.parties.map((p) => p.delegates.filter((d) => d === "NEUTRAL").length).reduce((a, c) => a + c, 0);
        const replacedCount = Math.min(neutralDelegateCount, playerTotalDelegateCount);
        for (let i = 0; i < replacedCount; i++) {
            game.defer(new DeferredAction_1.DeferredAction(player, () => {
                const partiesWithNeutralDelegates = turmoil.parties.filter((party) => party.delegates.includes("NEUTRAL")).map((party) => party.name);
                return new SelectPartyToSendDelegate_1.SelectPartyToSendDelegate(replaceNeutralDelegateTitle, 'Replace Neutral delegate', partiesWithNeutralDelegates, (partyName) => {
                    const source = turmoil.hasAvailableDelegates(player.id) ? 'reserve' : 'lobby';
                    turmoil.replaceDelegateFromParty("NEUTRAL", player.id, source, partyName, game);
                    player.totalDelegatesPlaced++;
                    const party = turmoil.getPartyByName(partyName);
                    turmoil.checkDominantParty(party);
                    game.log('${0} replaced Neutral delegate in ${1}', (b) => b.player(player).party(turmoil.getPartyByName(partyName)));
                    return undefined;
                });
            }));
        }
        player.addResource(Resources_1.Resources.MEGACREDITS, replacedCount * 3, { log: true });
        const availableParties = turmoil.parties.map((party) => party.name);
        const title = 'Select where to send a Neutral delegate';
        const previousDominantParty = turmoil.dominantParty.name;
        for (let i = 0; i < 3; i++) {
            game.defer(new DeferredAction_1.DeferredAction(player, () => {
                return new SelectPartyToSendDelegate_1.SelectPartyToSendDelegate(title, 'Send delegate', availableParties, (partyName) => {
                    turmoil.sendDelegateToParty('NEUTRAL', partyName, game);
                    game.log('${0} sent ${1} Neutral delegate in ${2} area', (b) => b.player(player).number(1).party(turmoil.getPartyByName(partyName)));
                    return undefined;
                });
            }));
        }
        game.defer(new DeferredAction_1.DeferredAction(player, () => {
            if (turmoil.dominantParty.name !== previousDominantParty) {
                Darwin_1.Darwin.onDominantPartyChange(game);
                game.log('${0} is the new dominant party', (b) => b.string(turmoil.dominantParty.name));
            }
            return undefined;
        }));
        this.isDisabled = true;
        return undefined;
    }
}
exports.Petra = Petra;
//# sourceMappingURL=Petra.js.map